import AuthRepository from './authRepository';
import AdminPosts from './admin/postsRepository';
import AdminUsers from './admin/usersRepository';
import AdminRegistrations from './admin/registrationsRepository';
import AdminTeams from './admin/teamsRepository';
import AdminSubjects from './admin/subjectsRepository';
import AdminLessons from './admin/lessonsRepository';
import AdminQuizzes from './admin/quizzesRepository';
import AdminHomework from './admin/homeworkRepository';
import PostsRepository from './postsRepository';
import UsersRepository from './usersRepository';
import SubjectsRepository from './subjectsRepository';
import LessonsRepository from './lessonsRepository';
import TeamsRepository from './teamsRepository';
import HomeworkRepository from './homeworkRepository';
import QuizzesRepository from './quizzesRepository';
import ResultsRepository from './resultsRepository';

const repositories = {
    auth: AuthRepository,
    admin: {
        posts: AdminPosts,
        users: AdminUsers,
        registrations: AdminRegistrations,
        teams: AdminTeams,
        subjects: AdminSubjects,
        lessons: AdminLessons,
        quizzes: AdminQuizzes,
        homework: AdminHomework,
    },
    posts: PostsRepository,
    users: UsersRepository,
    subjects: SubjectsRepository,
    lessons: LessonsRepository,
    teams: TeamsRepository,
    homework: HomeworkRepository,
    quizzes: QuizzesRepository,
    results: ResultsRepository
}

export const RepositoryFactory = {
    get: name => repositories[name],
    getAdmin: name => repositories['admin'][name]
}